module.exports = __webpack_public_path__ + "static/media/linkedin.894e0886.svg";